<footer class="ob-footer">
    <div class="container-fluid">
        <div class="row ob-footer-main">
            <div class="col-12 col-lg-3 ob-footer-brand">
                <a href="/" class="d-inline-flex text-decoration-none mb-3">
                    <img src="./assets/obrame-logo.png" alt="Obrame" width="140" height="30">
                </a>
                <p class="ob-footer-description">Obrame is workforce and payment management for rental properties. Find and invite service professionals to take care of your properties.</p>
            </div>
            <div class="col-12 col-lg-5 ob-footer-nav">
                <nav class="d-none d-lg-block">
                    <ul class="nav mb-2 justify-content-center mb-md-0">
                        <li><a href="{{publicWebUrl}}/product" routerLinkActive="active" class="nav-link">What is Obrame</a></li>
                        <li><a href="{{publicWebUrl}}/pricing" routerLinkActive="active" class="nav-link">Pricing</a></li>
                        <li><a href="{{publicWebUrl}}/company" class="nav-link">Company</a></li>
                    </ul>
                </nav>
            </div>
            <div class="col-12 col-lg-4"></div>
        </div>
        <div class="row ob-footer-bottom">
            <div class="col-12 col-md-6 d-flex align-items-center">
                <p class="ob-footer-copyright mb-0">&copy; 2026 Obrame.com part of Saman Ventures S.L. All rights reserved.</p>
            </div>
            <div class="col-12 col-md-6 d-flex justify-content-md-end justify-content-start align-items-center">
                <ul class="ob-footer-social list-unstyled d-flex mb-0">
                    <li>
                        <a href="https://www.youtube.com/@Obramecom" aria-label="YouTube">
                            <fa-icon [icon]="faYoutube" [fixedWidth]="true" size="lg"></fa-icon>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/84487195/admin/feed/posts/" aria-label="LinkedIn">
                            <fa-icon [icon]="faLinkedinIn" [fixedWidth]="true" size="lg"></fa-icon>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/obramecom/" aria-label="Instagram">
                            <fa-icon [icon]="faInstagram" [fixedWidth]="true" size="lg"></fa-icon>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.facebook.com/obramecom" aria-label="Facebook">
                            <fa-icon [icon]="faFacebook" [fixedWidth]="true" size="lg"></fa-icon>
                        </a>
                    </li>
                    <li>
                        <a href="https://twitter.com/obramecom" aria-label="X (Twitter)">
                            <fa-icon [icon]="faXTwitter" [fixedWidth]="true" size="lg"></fa-icon>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>